// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".check[data-v-2db43e8b]{color:#27846d}.list[data-v-2db43e8b]{display:flex}", ""]);
// Exports
module.exports = exports;
